import React from 'react';

import { FlexContainer } from '../../styled';
import { ChatErrorMessage, ErrorDetails, ErrorTitle, ViewDetailsStyled, WarningIcon } from './ChatErrorStyles';

interface IChatErrorProps {
  errorMessage: string;
  errorRetry?: () => void;
}

const ChatError = (props: IChatErrorProps) => {
  const { errorMessage, errorRetry } = props;

  return (
    <ChatErrorMessage>
      <FlexContainer spaceBetween>
        <div>
          <WarningIcon />
          <ErrorTitle>An Error Occured</ErrorTitle>
          <ErrorDetails>
            Click RETRY to try again. If this error persists, try refreshing your browser. The error is: {errorMessage}
          </ErrorDetails>
        </div>
        {errorRetry && <ViewDetailsStyled onClick={() => errorRetry()}>RETRY</ViewDetailsStyled>}
      </FlexContainer>
    </ChatErrorMessage>
  );
};

export default ChatError;
